import { Link } from "react-router-dom";
import { mockPrograms } from "@/mocks/programs";

export default function ProgramsPreview() {
  const featured = mockPrograms.slice(0, 4);

  return (
    <section className="py-24 bg-[#F7F6F3]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase">Programs</span>
            <h2
              className="text-4xl md:text-5xl font-bold text-gray-900 mt-3"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Transform With
              <br />
              <span className="text-teal-600">Expert-Led Programs</span>
            </h2>
          </div>
          <Link
            to="/programs"
            className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore All Programs <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map((program) => (
            <Link
              key={program.id}
              to="/programs"
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-teal-200 transition-all cursor-pointer block"
            >
              {/* Cover */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={program.cover}
                  alt={program.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-teal-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {program.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="bg-white/90 text-gray-700 text-xs font-medium px-2 py-1 rounded-full">
                    {program.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="font-semibold text-gray-900 text-sm mb-2 leading-snug">{program.title}</h3>
                <div className="flex items-center gap-2 mb-3">
                  <img
                    src={program.coachAvatar}
                    alt={program.coach}
                    className="w-6 h-6 rounded-full object-cover object-top"
                  />
                  <span className="text-gray-500 text-xs">{program.coach}</span>
                </div>
                <div className="flex items-center gap-1 mb-4">
                  <i className="ri-star-fill text-amber-400 text-xs" />
                  <span className="text-gray-700 text-xs font-semibold">{program.rating}</span>
                  <span className="text-gray-400 text-xs">({program.reviews})</span>
                  <span className="text-gray-300 text-xs mx-1">·</span>
                  <span className="text-gray-400 text-xs">{program.duration}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xl font-bold text-gray-900">${program.price}</span>
                  <span className="text-xs text-gray-400">{program.lessons} lessons</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
